var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"elementor elementor-8",attrs:{"data-elementor-type":"wp-page","data-elementor-id":"8"}},[_c('TitleSection'),_c('ControlSection'),_c('MedicationsSection'),_c('StepsSection'),_c('ScreenshotsSection')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }